<template>
    <el-tabs v-model="val" @tab-click="handleTabChange">
        <el-tab-pane :disabled="!root && val !== 'zh'" label="中文" name="zh"></el-tab-pane>
        <el-tab-pane :disabled="add || (!root && val !== 'en')" label="英文" name="en"></el-tab-pane>
        <el-tab-pane :disabled="add || (!root && val !== 'ru')" label="俄文" name="ru"></el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: "zh",
        },
        add: {
            type: Boolean,
            default: false,
        },
        root: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            val: "zh",
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    methods: {
        handleTabChange({ name }) {
            this.$emit("input", name);
            this.$emit("change", name);
        },
    },
};
</script>

<style></style>
